var _rect, _polygon, _text, _text2, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSachinIndustries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 240,
    fill: "#f8f9fa"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "120,30 195,72 195,138 120,180 45,138 45,72",
    fill: "#1f618d"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 118,
    fontFamily: "Arial Black, Arial, sans-serif",
    fontSize: 52,
    fontWeight: 900,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fill: "#ffffff",
    letterSpacing: 1
  }, "SI")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 210,
    fontFamily: "Arial, sans-serif",
    fontSize: 12,
    fontWeight: 700,
    textAnchor: "middle",
    fill: "#2c3e50"
  }, "Sachin Industries")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 228,
    fontFamily: "Arial, sans-serif",
    fontSize: 9,
    textAnchor: "middle",
    fill: "#7f8c8d"
  }, "Sachin Industries")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSachinIndustries);
export default __webpack_public_path__ + "static/media/Sachin_Industries.c1a50837bfd4ed72027e8035bf07beaf.svg";
export { ForwardRef as ReactComponent };